import type { Pinia } from 'pinia';

import type { Api } from '~/types/api';

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = nuxtApp.$pinia as Pinia;

  pinia.use(() => ({
    $api: nuxtApp.$api as Api,
  }));
});
